import { DefaultHeader, DefaultHeaderProps } from './DefaultHeader';
import { UserHeader, UserHeaderProps } from './UserHeader';

import { SubsidiarySiteFromUrlDocument } from '@graphql/generated/graphql';

import { AuthService } from '@services/AuthService/AuthService';

import { useQuery, useReactiveVar } from '@apollo/client';
import {
    authVar,
    forceDefaultNavigationVar,
    subsidiarySiteUuidFromUrlVar,
    tenantModulesVar,
} from '@boot/reactiveVariables';

export interface HeaderProps extends UserHeaderProps, DefaultHeaderProps {}

export const Header = (props: HeaderProps) => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;
    const forceDefaultNavigation = useReactiveVar(forceDefaultNavigationVar);

    const isSubsidiarySiteEnabled =
        useReactiveVar(tenantModulesVar).subsidiarySites;
    const subsidiarySiteUuidFromUrl = useReactiveVar(
        subsidiarySiteUuidFromUrlVar,
    );
    const tenantUuid = AuthService.getTenantUuid();

    const { data } = useQuery(SubsidiarySiteFromUrlDocument, {
        fetchPolicy: 'cache-and-network',
        skip: !isSubsidiarySiteEnabled,
        variables: {
            input: {
                subsidiaryUuid: subsidiarySiteUuidFromUrl || null,
                tenantUuid: tenantUuid || '',
            },
            tenantUuid: isLoggedIn ? undefined : tenantUuid,
        },
    });

    const currentSubsidiary = data?.subsidiarySite;
    const isHq = currentSubsidiary?.isHeadquarters ?? true;
    const currentSubsidiaryName =
        (isHq ? currentSubsidiary?.reportingLabel : currentSubsidiary?.name) ||
        '';

    return isLoggedIn && !forceDefaultNavigation ? (
        <UserHeader {...props} currentSubsidiary={currentSubsidiaryName} />
    ) : (
        <DefaultHeader {...props} currentSubsidiary={currentSubsidiaryName} />
    );
};
